
import { Search } from "lucide-react";

interface MobileSearchBoxProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

export const MobileSearchBox = ({
  searchQuery,
  setSearchQuery
}: MobileSearchBoxProps) => {
  return (
    <div className="px-3 py-2">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20 transition-all duration-200 text-sm bg-gray-50/80"
        />
      </div>
    </div>
  );
};
